import axios from 'axios';
import type { AnsweringSubscriptionLevel } from '@bb/domain/dist/types';

type ToggleUseAppointmentBody = {
  subscriptionType: AnsweringSubscriptionLevel;
  toggleOn: boolean;
};

const toggleUseAppointment = async (body: ToggleUseAppointmentBody) => {
  await axios.post('/listing/appointment_desk/toggle_all', body);
};

export default toggleUseAppointment;
